import { render, staticRenderFns } from "./EnvelopeSkeleton.vue?vue&type=template&id=65ced36c&scoped=true"
import script from "./EnvelopeSkeleton.vue?vue&type=script&lang=js"
export * from "./EnvelopeSkeleton.vue?vue&type=script&lang=js"
import style0 from "./EnvelopeSkeleton.vue?vue&type=style&index=0&id=65ced36c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "65ced36c",
  null
  
)

export default component.exports